export class CreateLedgerItemForPaymentModel {
  PaymentID: string;
  enumARLedgerItemOriginTypeID: string;
  enumARLedgerItemTypeID: string;
  DoctorARLocId: string;
}
